import imagenes from './Imagenes'; // Importamos las imágenes
import { Producto,Imagenes } from '../../types'; // Importamos el tipo Producto


export const productos:Producto[] = [
    { 
      id:1,
      product_cloud_Id:"camisa-101",
      titulo: "Camisas manga larga con botones para hombre",
      descripcion: "Camisa informal, para hombre con botones, lisa, adecuada para todas las ocasiones y estaciones como festividades, médicos interno de medicina, bioanalisis, enfermería cumpleaños, playa, casual, negocio informal, trabajo, vacaciones, citas, bodas y viajes. Las camisas clásicas para hombres te harán sentir guapo y elegante cuando la usas.",
      rating: 5,
      talla: ["S","M","L","XL","XXL"],
      material: "Algodón",
      categoria: "Camisas",
      cantidad: 1,
      stock: 100,
      precio: 1800.00,
      imagenes: [],
      isFeatured:true,
      color: ["Blanco","Azul","Negro"],
      especificaciones: [],
      descuento:50
    },

    {
      id:2,
        product_cloud_Id:"bata-101",
        titulo: "Bata Blanca Para Hombre",
        descripcion: "Diseño práctico: con una cómoda abertura lateral, esta bata de laboratorio ofrece un fácil acceso a los bolsillos de tus pantalones, lo que te permite recuperar artículos sin esfuerzo sin tener que levantar todo el abrigo torpemente alrededor de la parte delantera. Alta calidad: fabricado con una alta mezcla de algodón y poliéster; lo que te proporciona suavidad y durabilidad.",
        rating: 5,
        talla: ["S", "M", "L"],
        material: "Algodón y Poliéster",
        categoria: "Batas",
        cantidad: 1,
        stock: 50,
        isFeatured:true,
        precio: 950.00,
        imagenes: [],
        color: ["Blanco"],
        especificaciones: [],
        descuento:50
      },

      {
        id:3,
        product_cloud_Id:"bata-102",
        titulo: "Bata Blanca Para Mujeres",
        descripcion: "Nuestra bata de laboratorio con cinturón blanco cuenta con todos esos elementos que la convierten en una opción atemporal para cualquier entorno médico o laboratorio. Con un cuello inteligente y un diseño de abajo hacia abajo, nuestras batas de laboratorio por encima de la rodilla mantendrán tu ropa o ropa quirúrgica completamente protegida mientras garantizan un aspecto profesional y confiable.",
        rating: 0,
        talla: ["S", "M", "L"],
        material: "Algodón y Poliéster",
        categoria: "Batas",
        cantidad: 1,
        isFeatured:true,
        stock: 50,
        precio: 950.00,
        imagenes: [],
        color: ["Blanco"],
        especificaciones: [],
        descuento:50
      },

      {
        id:4,
        product_cloud_Id:"boligrafo-101",
        titulo: "Bolígrafos retráctiles de gel borrables",
        descripcion: "Corregir errores con facilidad: nuestros bolígrafos de gel retráctiles borrables cuentan con un borrador integrado, lo que te permite corregir fácilmente errores sin manchar o rasgar papel, lo que los hace perfectos para estudiantes y profesionales.\n\nTinta suave y consistente: experimenta la escritura suave y audaz de nuestros bolígrafos de gel borrables que ofrecen colores vibrantes y un flujo constante de tinta, lo que los hace perfectos para tomar notas, bocetos y colorear.\n\nVersátil y duradero: nuestros bolígrafos borrables son ideales para una amplia gama de usos, incluyendo tomar notas, bocetos y colorear. Con su diseño resistente y tinta de larga duración, seguramente se convertirán en tus bolígrafos favoritos.",
        rating: 1,
        talla: [],
        material: "Plástico",
        categoria: "Papelería",
        cantidad: 1,
        isFeatured:false,
        stock: 100,
        precio: 100.00,
        imagenes: [],
        color: ["Azul", "Negro", "Rojo"],
        especificaciones: [],
        descuento:50

      },
      {
        id:5,
        product_cloud_Id:"folder-101",
        titulo: "Carpeta Plegable",
        descripcion: "Plegable y portátil: este portapapeles adopta un diseño plegable de 3 capas que puede desde el tamaño completo de 12.2 x 9.4 pulgadas para ser doblado en el tamaño compacto de 9.4 x 4.3 x 0.8 pulgadas, conveniente para ser plano en la mano para tomar notas rápidas, diseño compacto y ligero se puede llevar fácilmente en sus bolsillos.",
        rating: 0,
        talla: [],
        material: "Plástico y cartón",
        categoria: "Papelería",
        cantidad: 1,
        isFeatured:false,
        stock: 50,
        precio: 499.00,
        imagenes: [],
        color: ["Negro", "Azul", "Rojo"],
        especificaciones: [],
        descuento:50

      },
      {
        id:6,
        product_cloud_Id:"carpeta-102",
        titulo: "Carpeta Portapapeles",
        descripcion: "Los portapapeles de plástico están hechos de material plástico de polipropileno de alto impacto, que es resistente al agua y no es fácil de romper. El clip de metal de perfil bajo también es lo suficientemente fuerte para un uso a largo plazo.",
        rating: 0,
        talla: [],
        material: "Polipropileno y metal",
        categoria: "Papelería",
        cantidad: 1,
        stock: 50,
        isFeatured:false,
        precio: 500.00,
        imagenes: [],
        color: ["Negro", "Azul", "Rojo"],
        especificaciones: [],
        descuento:50

      },
      {
        id:7,
        product_cloud_Id:"cinta-101",
        titulo: "Cinta Métrica Retráctil",
        descripcion: "Cinta métrica retráctil, cinta métrica de tela suave de 60 pulgadas para cuerpo, cinta métrica de costura con botón para cintura de tela.",
        rating: 0,
        talla: [],
        material: "Tela y plástico",
        categoria: "Costura",
        cantidad: 1,
        stock: 100,
        precio: 200.00,
        imagenes: [],
        isFeatured:false,
        color: ["Blanco", "Amarillo", "Rosa"],
        especificaciones: [],
        descuento:50

      },
      {
        id:8,
        product_cloud_Id:"clip-101",
        titulo: "Clip Retráctil Para Porta Carnet",
        descripcion: "Diseño retráctil: cada clip de identificación cuenta con un cable retráctil de nailon de 24 pulgadas, para que puedas escanear tu tarjeta sin quitarla, lo que es muy cómodo de usar, y no tienes que preocuparte por perderlo también; el diámetro del clip de tarjeta de identificación es de aproximadamente 1.18 pulgadas. Adecuado para el personal de oficina, estudiantes, trabajadores, enfermeras, voluntarios para llevar portatarjetas de identificación, titulares de tarjetas de identificación.",
        rating: 0,
        talla: [],
        material: "Nailon y plástico",
        categoria: "Accesorios de oficina",
        cantidad: 1,
        stock: 100,
        isFeatured:false,
        precio: 100.00,
        imagenes: [],
        color: ["Negro", "Azul", "Rojo"],
        especificaciones: [],
        descuento:50

      },
      {
        id:9,
        product_cloud_Id:"clip-102",
        titulo: "Clip para Tarjetas de Identificación",
        descripcion: "Portatarjetas retráctiles, carretes retráctil para insignias en varias citas de patrones, bonito regalo para regalos de enfermera, compartir con tu colega, compañeros de trabajo, amigos y familiares.\n\nDiseño motivacional: están hechas con palabras motivacionales y bonitos patrones, para que puedas ver tus objetivos y motivación todos los días, y transmitir tu energía positiva.",
        rating: 0,
        isFeatured:false,
        talla: [],
        material: "Plástico y metal",
        categoria: "Accesorios de oficina",
        cantidad: 1,
        stock: 100,
        precio: 200.00,
        imagenes: [],
        color: ["Negro", "Azul", "Rosa"],
        especificaciones: [],
        descuento:50

      },
      {
        id:10,
        product_cloud_Id:"correa-101",
        titulo: "Correa de Muñeca para Levantamiento de Pesas",
        descripcion: "Correa de muñeca de levantamiento de pesas mejorada, hecha de cuero suave de doble capa de alta calidad y ergonómicamente diseñada para adaptarse a tus manos, proporcionando un mejor agarre. La adición de acolchado adicional alrededor del cierre de anillo de metal en forma de D evita que tu muñeca se apriete y se sienta dolorosa. La correa con gancho y bucle de alta densidad es fácil de llevar y quitar por ti mismo. La almohadilla de neopreno ampliada te proporciona comodidad durante el uso.",
        rating: 0,
        talla: [],
        isFeatured:false,
        material: "Cuero, neopreno, metal",
        categoria: "Accesorios para entrenamiento",
        cantidad: 1,
        stock: 100,
        precio: 1300.00,
        imagenes: [],
        color: ["Negro", "Gris"],
        especificaciones: [],
        descuento:50

      },
      {
        id:11,
        product_cloud_Id:"estuche-101",
        titulo: "Estuche Para Estetoscopio",
        descripcion: "El estuche para estetoscopio está fabricado con materiales de alta calidad, semi-impermeables y a prueba de golpes, ofreciendo una excelente protección para evitar daños a tu valioso estetoscopio y accesorios.",
        rating: 0,
        talla: [],
        material: "Materiales semi-impermeables y a prueba de golpes",
        categoria: "Accesorios médicos",
        cantidad: 1,
        stock: 100,
        isFeatured:false,
        precio: 1250.00,
        imagenes: [],
        color: ["Negro", "Azul"],
        especificaciones: [],
        descuento:50

      },
      {
        id:12,
        product_cloud_Id:"fono-101",
        titulo: "Foco Ocular",
        descripcion: "Estos focos de alta calidad son herramientas ideales para enfermeras, médicos y estudiantes de medicina. Son ligeros, de tamaño práctico y cuentan con un diseño elegante.",
        rating: 0,
        talla: [],
        material: "Alta calidad",
        categoria: "Equipos médicos",
        cantidad: 1,
        stock: 100,
        isFeatured:false,
        precio: 300.00,
        imagenes: [],
        color: ["Blanco", "Negro"],
        especificaciones: [],
        descuento:50

      },
      
      {
        id:13,
        product_cloud_Id:"gorro-101",
        titulo: "Gorro Qx Ovalado Femenino",
        descripcion: "Estos gorros elásticos están hechos de algodón, lo que garantiza una experiencia de uso cómoda. Son suaves, cómodos de llevar, lavables y duraderos, no se rompen ni decoloran fácilmente, permitiéndote usarlos durante mucho tiempo.",
        rating: 0,
        talla: [],
        isFeatured:false,
        material: "Algodón",
        categoria: "Ropa médica",
        cantidad: 1,
        stock: 100,
        precio: 255.00,
        imagenes: [],
        color: ["Rosa", "Blanco", "Negro"],
        especificaciones: [],
        descuento:50

      },
      {
        id:14,
        product_cloud_Id:"gorro-102",
        titulo: "Gorros De Enfermera",
        descripcion: "Estos gorros Qx adoptan un diseño de botones en ambos lados, lo que te permite fijar la mascarilla a los botones en lugar de tus orejas, aliviando el dolor y la presión en las orejas, proporcionando una manera más cómoda de llevar la mascarilla.",
        rating: 0,
        talla: [],
        isFeatured:false,
        material: "Alta calidad",
        categoria: "Ropa médica",
        cantidad: 1,
        stock: 100,
        precio: 300.00,
        imagenes: [],
        color: ["Azul", "Rosa", "Verde"],
        especificaciones: [],
        descuento:50

      },
      {
        id:15,
        product_cloud_Id:"gorro-103",
        titulo: "Gorros Quirúrgicos",
        descripcion: "Estos gorros de trabajo ajustables están hechos de tela de algodón con banda para el sudor en el interior de la cabeza, que absorbe el sudor, se siente suave al tacto, no estrangula la cabeza, no se decolora, y el gorro tiene una larga vida útil y se puede lavar y reutilizar.",
        rating: 0,
        talla: [],
        material: "Alta calidad",
        categoria: "Ropa médica",
        cantidad: 1,
        stock: 100,
        isFeatured:false,
        precio: 250.00,
        imagenes: [],
        color: ["Azul", "Rosa", "Verde"],
        especificaciones: [],
        descuento:50

      },
      {
        id:16,
        product_cloud_Id:"gorro-104",
        titulo: "Gorros Qx Enfermera Sin Estampados",
        descripcion: "Material de calidad: los gorros de enfermera están hechos de tela de algodón de calidad, suave, ligera, cómoda, transpirable, de secado rápido, no se decolora ni encoge fácilmente, lo que te ofrece una experiencia de uso cómoda, se recomienda lavar a mano.",
        rating: 0,
        talla: [],
        material: "Alta calidad",
        categoria: "Ropa médica",
        cantidad: 1,
        stock: 100,
        precio: 300.00,
        isFeatured:false,
        imagenes: [],
        color: ["Azul", "Rosa", "Verde"],
        especificaciones: [],
        descuento:50

      },
      {
        id:17,
        product_cloud_Id:"gorro-105",
        titulo: "Gorros Qx Femeninos Cola De Caballo",
        descripcion: "Este gorro de cola de caballo con lazo está hecho principalmente de material de algodón, mano de obra fina, claridad de diseño, suave al tacto, cómodo de llevar, ligero y transpirable.",
        rating: 0,
        talla: [],
        material: "Alta calidad",
        categoria: "Ropa médica",
        isFeatured:false,
        cantidad: 1,
        stock: 100,
        precio: 300.00,
        imagenes: [],
        color: ["Azul", "Rosa", "Verde"],
        especificaciones: [],
        descuento:50

      },
      {
        id:18,
        product_cloud_Id:"gorro-106",
        titulo: "Gorros Qx para Hombres",
        descripcion: "Material de calidad y diseño cómodo: las gorras están fabricadas con material de algodón de calidad que es ligero y transpirable, proporcionando una comodidad y satisfacción óptimas; estas gorras cuentan con un diseño de banda de sudor suave y absorbente que absorbe rápidamente el sudor, manteniendo la frente limpia y seca, y el cabello limpio y ordenado.",
        rating: 0,
        talla: [],
        isFeatured:false,
        material: "Alta calidad",
        categoria: "Ropa médica",
        cantidad: 1,
        stock: 100,
        precio: 400.00,
        imagenes: [],
        color: ["Azul", "Rosa", "Verde"],
        especificaciones: [],
        descuento:50

      },
      
      {
        id:19,
        product_cloud_Id:"kit-piezas-101",
        titulo: "Kit de Piezas de Repuesto para Estetoscopio 3M™ Littmann® Classic III™, Cardiology IV™ y CORE, 40016, Negro",
        descripcion: "Sustituye las puntas de los oídos, diafragmas y manguito de campana sin frío en los estetoscopios Classic III, Cardiology IV o CORE Digital. Este kit ofrece calidad y fiabilidad en un paquete conveniente. Contiene un diafragma de una sola pieza ajustable para el lado adulto de la pieza torácica, color negro. También incluye un diafragma ajustable para el lado pediátrico y una manga acampanada que no se enfría, todo en color negro.",
        rating: 0,
        talla: [],
        material: "Alta calidad",
        categoria: "Accesorios médicos",
        cantidad: 1,
        isFeatured:false,
        stock: 100,
        precio: 2150.00,
        imagenes: [],
        color: ["Negro"],
        especificaciones: [],
        descuento:50

      },

      {
        id:20,
        product_cloud_Id:"boligrafo-102",
        titulo: "Lapiceros Con Forma De Huesos",
        descripcion: "El bolígrafo de hueso es resistente a la abrasión y tiene una durabilidad excelente. Su tinta de gel de alto rendimiento ofrece una experiencia de escritura suave. Además, el bolígrafo es ligero, lo que permite llevarlo fácilmente en tu bolso o bolsillo.",
        rating: 0,
        talla: [],
        material: "Plástico, tinta de gel",
        categoria: "Accesorios de oficina",
        cantidad: 1,
        stock: 100,
        isFeatured:false,
        precio: 50.00,
        imagenes: [],
        color: ["Blanco"],
        especificaciones: [],
        descuento:50

      },
      {
        id:21,
        product_cloud_Id:"llavero-101",
        titulo: "Llavero MED",
        descripcion: "Un llavero ideal para complementar y adornar tus llaves, mochilas, bultos, etc. Perfecto para personal médico, contiene múltiples estilos de dijes temáticos médicos. Estos llaveros duraderos y bien hechos son un excelente regalo para el día de la enfermera, la semana de la enfermera, recuerdos de graduación médica, y más.",
        rating: 0,
        talla: [],
        material: "Metal, plástico",
        categoria: "Accesorios para profesionales de la salud",
        cantidad: 1,
        stock: 100,
        precio: 200.00,
        imagenes: [],
        isFeatured:false,
        color: ["Plata", "Negro"],
        especificaciones: [],
        descuento:50

      },
      {
        id:22,
        product_cloud_Id:"llavero-102",
        titulo: "Llavero Stich",
        descripcion: "Este bonito llavero está hecho de PVC de alta calidad y hardware resistente, lo que le permite soportar el desgaste diario y garantizar un uso a largo plazo. Es ligero, portátil, compacto y fácil de almacenar, asegurando que siempre esté contigo.",
        rating: 0,
        talla: [],
        material: "PVC, hardware",
        categoria: "Accesorios",
        cantidad: 1,
        stock: 100,
        precio: 200.00,
        isFeatured:false,
        imagenes: [],
        color: ["Multicolor"],
        especificaciones: [],
        descuento:50

      },
      {
        id:23,
        product_cloud_Id:"medias-101",
        titulo: "Medias De Compresión",
        descripcion: "Estas medias de compresión están hechas de tela ligera y poliamida, con hilo que absorbe la humedad y malla transpirable, alejando la transpiración de la piel para mantener tus pies secos y frescos durante todo el día. Son perfectas para cualquier temporada, ya sea verano o invierno.",
        rating: 0,
        talla: ["S", "M", "L", "XL"],
        material: "Poliamida, tela ligera",
        categoria: "Ropa deportiva",
        isFeatured:false,
        cantidad: 1,
        stock: 100,
        precio: 950.00,
        imagenes: [],
        color: ["Negro", "Blanco", "Azul"],
        especificaciones: [],
        descuento:50

      },
      {
        id:24,
        product_cloud_Id:"mochila-101",
        titulo: "Mochila Cangurera",
        descripcion: "Esta mochila cangurera está fabricada en nailon resistente al desgaste, con malla lumbar transpirable para mayor comodidad. Cuenta con un cinturón de ajuste organizable externo, soportes dobles para botellas de agua, tres bolsillos delanteros exteriores con cremallera y dos bolsillos laterales exteriores con cremallera para mantener tus cosas separadas y organizadas.",
        rating: 0,
        talla: [],
        isFeatured:false,
        material: "Nailon, malla",
        categoria: "Accesorios de viaje",
        cantidad: 1,
        stock: 100,
        precio: 1360.00,
        imagenes: [],
        color: ["Negro", "Azul", "Gris"],
        especificaciones: [],
        descuento:50

      },
      {
        id:25,
        product_cloud_Id:"muneca-101",
        titulo: "Muñequera de Compresión",
        descripcion: "Hecha de 68% nailon de alta calidad y 32% elastano, esta muñequera está diseñada para brindar comodidad durante todo el día. Es flexible, absorbe la humedad, antiolor, transpirable y ultra duradera. Proporciona soporte y protección para la muñeca, aliviando la rigidez muscular, el dolor y ofreciendo alivio rejuvenecedor de la artritis, osteoporosis, tendinitis, y otras molestias. Su doble cuidado mejora la circulación y estimula el flujo de oxígeno a los músculos. Incluye una banda adicional con velcro para ajustar la presión.",
        rating: 0,
        isFeatured:false,
        talla: ["S", "M", "L"],
        material: "68% nailon, 32% elastano",
        categoria: "Accesorios de salud",
        cantidad: 1,
        stock: 100,
        precio: 450.00,
        imagenes: [],
        color: ["Negro", "Azul", "Gris"],
        especificaciones: [],
        descuento:50

      },
      {
        id:26,
        titulo: "Muñequera para Túnel Carpiano",
        descripcion: "Soporte de muñeca de alta calidad que ayuda a mejorar la estabilidad, prevenir más lesiones y reducir el dolor con un diseño largo, ajustable y de apoyo. Hecho de neopreno. La compresión apretada mejora el flujo sanguíneo y la circulación, mientras que las correas ajustables ayudan a prevenir el movimiento, ideal para aliviar el dolor de lesiones. Es apta para problemas comunes como síndrome del túnel carpiano, artritis, esguinces, recuperación de lesiones, entre otros. Cuenta con un sistema de correa de ajuste rápido, ideal para deportes, fitness, levantamiento de pesas o estilos de vida activos.",
        rating: 0,
        isFeatured:false,
        talla: ["S", "M", "L"],
        material: "Neopreno",
        categoria: "Accesorios de salud",
        cantidad: 1,
        stock: 100,
        precio: 1950.00,
        imagenes: [],
        color: ["Negro", "Gris"],
        especificaciones: [],
        product_cloud_Id: "muneca-102",
        descuento:50

      },
      {
        id:27,
        titulo: "Paquete de Hielo Facial",
        descripcion: "Este paquete de hielo facial es ideal para reducir el dolor y la hinchazón, ya sea por dolor de muelas o cirugía estética. La compresa rester's choice es manos libres, y se puede usar tanto fría como caliente. La correa ajustable permite un ajuste perfecto, desde 27 hasta 30 pulgadas, para adaptarse a diferentes tamaños y brindar una compresión ligera o envoltura más pequeña.",
        rating: 0,
        talla: [],
        material: "No especificado",
        isFeatured:false,
        categoria: "Salud y bienestar",
        cantidad: 1,
        stock: 100,
        precio: 950.00,
        imagenes: [],
        color: ["Azul", "Transparente"],
        especificaciones: [],
        product_cloud_Id: "paquete-de-hielo-facial-101",
        descuento:50

      },
      {
        id:28,
        titulo: "Pin de Estetoscopio",
        descripcion: "Pin de estetoscopio en 8 estilos, ideales para su uso diario, reemplazo y para compartir con amigos. Cada pin mide aproximadamente 1.18 x 0.63 pulgadas, pesa 0.07 onzas, lo que lo hace ligero y fácil de transportar. Diseñado con forma de estetoscopio, realista y exquisito en mano de obra y colores brillantes. Perfecto para decorar suéteres, bufandas, vestidos, bolsos, ropa, sombreros y otros artículos, mostrando buen gusto y una impresión fresca.",
        rating: 0,
        talla: [],
        isFeatured:false,
        material: "Metal",
        categoria: "Accesorios",
        cantidad: 1,
        stock: 100,
        precio: 150.00,
        imagenes: [],
        color: ["Plateado", "Dorado"],
        especificaciones: [],
        product_cloud_Id: "pin-de-estetoscopio-101",
        descuento:50

      },
      {
        id:29,
        titulo: "Pines Esmaltados",
        descripcion: "Los mejores pines esmaltados anatómicos en forma de pulmones respiratorios, corazón y cerebro. Perfectos para colocarlos en mochilas, jeans, sombreros, bufandas, etc. También ideales como regalo para un estudiante de medicina, médico o enfermera. Hechos de metal galvanizado de alta calidad y esmalte.",
        rating: 0,
        talla: [],
        isFeatured:false,
        material: "Metal galvanizado, Esmalte",
        categoria: "Accesorios",
        cantidad: 1,
        stock: 100,
        precio: 200.00,
        imagenes: [],
        color: ["Multicolor"],
        especificaciones: [],
        product_cloud_Id: "pines-esmaltados-101",
        descuento:50

      },
      {
        id:30,
        titulo: "Plantillas resistentes para aliviar el dolor",
        descripcion: "Soporte resistente: proporciona soporte de arco y absorbe los golpes con cada paso para aliviar la fascitis plantar. Diseño de arco alto: plantilla de espuma con soporte de arco medio para hombres y soporte de arco alto para mujeres. Compatible con botas y zapatos: se adapta a botas y zapatos para el trabajo o uso casual. Material de espuma: material de plantilla duradero y acolchado que absorbe los golpes y proporciona comodidad. Diseño unisex: Disponible en tallas de hombre y mujer.",
        rating: 0,
        talla: [],
        isFeatured:false,
        material: "Espuma",
        categoria: "Accesorios de salud",
        cantidad: 1,
        stock: 100,
        precio: 1350.00,
        imagenes: [],
        color: ["Negro", "Beige"],
        especificaciones: [],
        product_cloud_Id: "plantillas-resistentes-para-aliviar-el-dolor-101",
        descuento:50

      },
      {
        id:31,
        titulo: "Porta Carnet",
        descripcion: "Porta carnet retráctiles varios colores, incluyendo rojo, amarillo, azul, verde, negro, blanco, naranja, rosa, azul cielo, rojo rosa, verde claro y morado; una variedad de colores puede satisfacer tus preferencias y combinar fácilmente con diferentes estilos de ropa.\n\nUso versátil: independientemente de su edad, sexo o temporada, puedes enganchar el carrete decorativo de identificación donde lo necesites. Es agradable para enfermeras, médicos, estudiantes, profesores, personal de oficina, voluntarios y más; se pueden seleccionar 12 colores diferentes de acuerdo con diferentes estilos de ropa o preferencias.\n\nPuedes enganchar el soporte de la insignia de nombre a tu cuello, bolsillo de la camisa, cinturón, mochila y cualquier lugar que quieras con el clip de cocodrilo metálico; este soporte puede ayudarte a llevar tarjeta de identificación, tarjeta de visita, permiso de trabajo, llaves y otros artículos.",
        rating: 0,
        talla: [],
        isFeatured:false,
        material: "Plástico y metal",
        categoria: "Accesorios de oficina",
        cantidad: 1,
        stock: 100,
        precio: 150.00,
        imagenes: [],
        color: ["Rojo", "Amarillo", "Azul", "Verde", "Negro", "Blanco", "Naranja", "Rosa", "Azul Cielo", "Rojo Rosa", "Verde Claro", "Morado"],
        especificaciones: [],
        product_cloud_Id: "porta-carnet-101",
        descuento:50

      },
      {
        id:32,
        titulo: "Porta Carnet Azul",
        descripcion: "Porta carnet con soportes deslizantes para tarjetas de identificación con clips retráctiles, soporte retráctil de plástico duro para carnet.",
        rating: 0,
        talla: [],
        isFeatured:false,
        material: "Plástico",
        categoria: "Accesorios de oficina",
        cantidad: 1,
        stock: 100,
        precio: 250.00,
        imagenes: [],
        color: ["Azul"],
        especificaciones: [],
        product_cloud_Id: "porta-carnet-azul-101",
        descuento:50

      },
      {
        id:33,
        titulo: "Porta carnet Grey Anatomy",
        descripcion: "Diseño único y soporte para carnet de identificación: ¿Estás aburrido de los soportes de carnet aburridos y los cordones simples? ¿Quieres algo bonito y llamativo? Ahora tenemos los porta carnet para carnet de identificación y soporte con patrón elegante y bonito para que elijas. Si quieres cambiar tu tediosa vida, puedes comenzar con este colorido y único soporte para carnet.",
        rating: 0,
        talla: [],
        isFeatured:false,
        material: "Plástico y tela",
        categoria: "Accesorios de oficina",
        cantidad: 1,
        stock: 100,
        precio: 300.00,
        imagenes: [],
        color: ["Gris"],
        especificaciones: [],
        product_cloud_Id: "porta-carnet-grey-anatomy-101",
        descuento:50

      },
      {
        id:34,
        titulo: "Porta carnet Harry Potter",
        descripcion: "Este soporte para carnet se puede utilizar perfectamente para hombres de negocios, empleados, estudiantes, profesores, médicos, mensajeros, enfermeras, bioanalistas, camareros, etc. Este soporte para carnet de identificación es definitivamente tu mejor opción.",
        rating: 0,
        talla: [],
        isFeatured:false,
        material: "Plástico y tela",
        categoria: "Accesorios de oficina",
        cantidad: 1,
        stock: 100,
        precio: 300.00,
        imagenes: [],
        color: ["Varios colores disponibles"],
        especificaciones: [],
        product_cloud_Id: "porta-carnet-harry-potter-101",
        descuento:50

      },
      {
        id:35,
        titulo: "Porta carnet MED",
        descripcion: "Este tarjetero con una bonita impresión temática médica es versátil y exquisito. Se adapta a muchas escenas de la vida, como oficinas y escuelas, especialmente hospitales. Este protector de tarjetas vertical con un patrón impresionante es encantador y desviador. Usándolo, tu atuendo de trabajo se verá más vibrante.",
        rating: 0,
        talla: [],
        isFeatured:false,
        material: "Plástico y tela",
        categoria: "Accesorios de oficina",
        cantidad: 1,
        stock: 100,
        precio: 300.00,
        imagenes: [],
        color: ["Varios colores disponibles"],
        especificaciones: [],
        product_cloud_Id: "porta-carnet-med-101",
        descuento:50

      },
      {
        id:36,
        titulo: "Porta carnet Stich",
        descripcion: "Soporte para carnet de identificación, fácil de abrir la funda deslizando la cubierta trasera hacia arriba y cerrar la funda deslizándola hacia abajo. Una cincha para encerrar o quitar tu tarjetas de identificación sin esfuerzo.",
        rating: 0,
        talla: [],
        material: "Plástico",
        isFeatured:false,
        categoria: "Accesorios de oficina",
        cantidad: 1,
        stock: 100,
        precio: 300.00,
        imagenes: [],
        color: ["Varios colores disponibles"],
        especificaciones: [],
        product_cloud_Id: "porta-carnet-stich-101",
        descuento:50

      },
      {
        id:37,
        titulo: "Pulso Oximetro Blv",
        descripcion: "Resultados precisos y rápidos: mide con precisión y rapidez spo2 (saturación de oxígeno en sangre de los niveles de hemoglobina arterial), frecuencia de pulso, forma de onda de frecuencia de pulso y pantalla TFT de gráficos de barras. Con pantalla giratoria multidireccional. Brillo de pantalla ajustable.\n\nPortátil y fácil de usar: el monitor de oxígeno ligero pesa aproximadamente 1.76 oz (con las baterías), solo necesitas poner tu dedo en la cámara de prueba de oxímetro de pulso de dedo, se mostrará el resultado.",
        rating: 0,
        talla: [],
        isFeatured:false,
        material: "Plástico",
        categoria: "Dispositivos médicos",
        cantidad: 1,
        stock: 100,
        precio: 950.00,
        imagenes: [],
        color: ["Varios colores disponibles"],
        especificaciones: [],
        product_cloud_Id: "pulso-oximetro-blv-101",
        descuento:50

      },
      {
        id:38,
        titulo: "Pulso Oximetro Pediátrico",
        descripcion: "Monitor de frecuencia cardíaca de saturación de oxígeno en sangre con apagado automático, pantalla OLED de una dirección, incluye 2 pilas, desarrollado para niños: este oxímetro de pulso de dedo se adapta a niños, cuando mides, tu dedo y cuerpo no tiemblan durante la medición, por favor manténgalo quieto, evita fallas en la medición.",
        rating: 0,
        talla: [],
        isFeatured:false,
        material: "Plástico",
        categoria: "Dispositivos médicos",
        cantidad: 1,
        stock: 100,
        precio: 1750.00,
        imagenes: [],
        color: ["Varios colores disponibles"],
        especificaciones: [],
        product_cloud_Id: "pulso-oximetro-pediatrico-101",
        descuento:50

      },
      {
        id:39,
        titulo: "Pulso Oximetro IMDK",
        descripcion: "El oxímetro de pulso de dedo IMDK utiliza la última tecnología de sensor de oxígeno para determinar con precisión el nivel de oxígeno en la sangre (SpO2) en 8 segundos. El rango de medición es del 70% - 99% con ±2% de precisión y ±1% de resolución. El oxímetro de pulso de dedo IMDK se adapta a todos los tamaños de dedo y proporciona 6.000 comprobaciones puntuales. Es fácil de operar con un solo botón y viene con un cordón para facilitar su transporte. Un pitido de alarma para indicar el nivel de oxígeno y la frecuencia cardíaca. Para ahorrar energía, se apaga automáticamente después de 8 segundos.",
        rating: 0,
        talla: [],
        isFeatured:false,
        material: "Plástico",
        categoria: "Dispositivos médicos",
        cantidad: 1,
        stock: 100,
        precio: 1900.00,
        imagenes: [],
        descuento:50,
        color: ["Varios colores disponibles"],
        especificaciones: [
          "SpO2 Rango de medición: 70% - 99%",
          "Precisión: ±2% (70%-99%), no especificado (<70%)",
          "Frecuencia de pulsaciones: 30 BPM - 240 BPM",
          "Resolución: ±1%",
          "Precisión: ±2bpm o +2% (seleccione más grande)",
          "Baja Perfusión ≤0,4%"
        ],
        product_cloud_Id: "pulso-oximetro-imdk-101"
      },
      {
        id:40,
        titulo: "Resaltador Con Forma De Jeringuilla",
        descripcion: "Los rotuladores de jeringa están hechos principalmente de plástico de calidad, fiable y fuerte, no es fácil de romper o deformar, puedes marcar fácilmente el texto y las líneas.",
        rating: 0,
        talla: [],
        material: "Plástico",
        categoria: "Escritorio",
        descuento:50,
        cantidad: 1,
        stock: 100,
        precio: 50.00,
        isFeatured:false,
        imagenes: [],
        color: ["Varios colores disponibles"],
        especificaciones: [],
        product_cloud_Id: "resaltador-jeringuilla-101"
      },
      {
        id:41,
        titulo: "Rodillera con bisagra",
        descripcion: "La rodillera con bisagra alivia el dolor, molestia y evita el desgarro del menisco, la artritis, el dolor de tendón. Diseño de rótula abierta con estabilizadores laterales de metal doble. Soporte para correr, para hombres y mujeres.",
        rating: 0,
        talla: [],
        descuento:50,
        material: "Metal, tela",
        categoria: "Salud",
        cantidad: 1,
        stock: 100,
        isFeatured:false,
        precio: 1900.00,
        imagenes: [],
        color: ["Negro"],
        especificaciones: [],
        product_cloud_Id: "rodillera-bisagra-101"
      },
      {
        id:42,
        titulo: "Rodillera profesional para dolor de rodilla",
        descripcion: "Tecnología de apoyo para la rodilla: una almohadilla de gel de rótula contorneada anatómicamente rodea tu rótula, los estabilizadores de cobre extraíbles de doble lado con bisagras se ajustan firmemente a tu articulación. Estos elementos funcionales especiales fortalecen el soporte lateral y mantienen la estabilidad de las articulaciones, proporcionando el máximo apoyo para la articulación de la rodilla, infunden iones de cobre de forma innovadora en los estabilizadores de resorte para ayudar a controlar tu movimiento, ayudar eficazmente al tratamiento de recuperación de la rodilla. Es la mejor opción para la protección deportiva y la recuperación del dolor.",
        rating: 0,
        talla: [],
        material: "Gel, cobre, resorte",
        categoria: "Salud",
        cantidad: 1,
        stock: 100,
        precio: 3900.00,
        isFeatured:false,
        imagenes: [],
        color: ["Negro"],
        especificaciones: [],
        product_cloud_Id: "rodillera-profesional-101",
        descuento:50

      },
      {
        id:43,
        titulo: "Soporte de cuello para dolor de cuello y apoyo",
        descripcion: "Alivio del dolor de cuello: nuestro soporte para el cuello soporta la mandíbula y el cuello mientras limita un cierto rango de movilidad del cuello para ayudar a aliviar el dolor y la presión en la columna cervical, ayuda a reducir la presión sobre el nervio, ayuda a ajustar la postura del cuello, dolor de cuello, fatiga del cuello y estabilizar las vértebras. Este cuello cervical con funda se puede utilizar para terapia en casa o como estirador de cuello.",
        rating: 0,
        talla: [],
        material: "No especificado",
        categoria: "Salud",
        cantidad: 1,
        stock: 100,
        precio: 2500.00,
        isFeatured:false,
        imagenes: [],
        color: ["No especificado"],
        especificaciones: [],
        product_cloud_Id: "soporte-cuello-101",
        descuento:50

      },
      {
        id:44,
        titulo: "Tijeras De Trauma",
        descripcion: "Corta cualquier cosa de forma segura y eficiente con estas tijeras médicas afiladas de grado profesional.\n\nEl borde inferior dentado mejorado (dentado) corta a través de materiales resistentes\n\nBorde de elevación de ropa y punta redondeada para la seguridad del paciente\n\nAsas contorneadas antideslizantes de agarre suave para un máximo control y comodidad",
        rating: 0,
        talla: [],
        material: "No especificado",
        categoria: "Salud",
        cantidad: 1,
        stock: 100,
        precio: 300.00,
        imagenes: [],
        isFeatured:false,
        color: ["No especificado"],
        especificaciones: [],
        product_cloud_Id: "tijeras-trauma-101",
        descuento:50

      },
      {
        id:45,
        titulo: "Tobillera",
        descripcion: "Calidad premium, están hechos de tejido de punto, que puede proporcionar un apoyo y comodidad superiores sin comprometer su movilidad. Transpirable y absorbe el sudor, mantiene la estabilidad de las articulaciones y absorbe el sudor rápidamente para mantener tu piel seca y sin olor.\n\nCómoda y gran protección: esta manga de compresión de tobillo estabiliza y apoya la articulación. Reduce la hinchazón y el dolor de la fascitis plantar, mejora la circulación sanguínea y protege los tobillos de lesiones. Se puede llevar a diario según sea necesario.\n\nDiseño antideslizante: las mangas de tobillo tienen alta elasticidad, su soporte de tobillo se ajustará firmemente y cómodamente.",
        rating: 0,
        talla: [],
        material: "Tejido de punto",
        categoria: "Salud",
        cantidad: 1,
        isFeatured:false,
        stock: 100,
        precio: 850.00,
        imagenes: [],
        color: ["No especificado"],
        especificaciones: [],
        product_cloud_Id: "tobillera-101",
        descuento:50

      },
      {
        id:46,
        titulo: "Torniquetes Ewinever",
        descripcion: "Turniquete de emergencia médica, cinta de algodón altamente flexible, sin látex que es suave con la piel. Más seguro, más duradero, más conveniente. Sin dolor al apretar el torniquete. Cobertura ergonómica, clip resistente a presión.",
        rating: 0,
        talla: [],
        material: "Cinta de algodón sin látex",
        categoria: "Salud",
        cantidad: 1,
        isFeatured:false,
        stock: 100,
        precio: 200.00,
        imagenes: [],
        color: ["No especificado"],
        especificaciones: [],
        product_cloud_Id: "torniquete-ewinever-101",
        descuento:50

      },
      {
        id:47,
        titulo: "Zuecos para mujer",
        descripcion: "Zuecos para mujer, con correa, para el trabajo médico de enfermería, 100% espuma EVA, resistente al agua. Correa de talón ajustable para garantizar un ajuste adecuado. Comodidad durante todo el día, soporte de arco alto y plantilla Suela sin marcas, antideslizante.",
        rating: 0,
        talla: [],
        material: "Espuma EVA",
        categoria: "Calzado",
        isFeatured:false,
        cantidad: 1,
        stock: 100,
        precio: 1200.00,
        imagenes: [],
        color: ["No especificado"],
        especificaciones: [],
        product_cloud_Id: "zuecos-mujer-101",
        descuento:50

      },

      {
        id:48,
        titulo: "Pin Con Forma De Corazon",
        descripcion: "Broches de corazón anatómicos, insignia de solapa esmaltada, excelente acabado. Material: los pines de solapa de esmalte de corazón anatómico están hechos de aleación de zinc, mano de obra fina. El diseño de cierre de mariposa en la parte posterior del pin de esmalte hace que sea fácil de fijar en tu ropa.",
        rating: 0,
        talla: [],
        material: "Aleación de zinc",
        categoria: "Accesorios",
        isFeatured: false,
        cantidad: 1,
        stock: 100,
        precio: 200.00,
        imagenes: [],
        color: ["No especificado"],
        especificaciones: [],
        product_cloud_Id: "pin-corazon-101",
        descuento:50

      },
      {
        id: 49,
        titulo: "Pin Corazon Rojo",
        descripcion: "El diseño de broche de corazón para enfermera/doctor, estudiantes de graduación médica es exquisito y práctico, fácil de combinar y puede hacer que llames la atención de otras personas, también es un buen regalo para médicos, bioanalistas, enfermeras, estudiantes, etc.",
        rating: 0,
        talla: [],
        material: "No especificado",
        categoria: "Accesorios",
        isFeatured: false,
        descuento:50,
        cantidad: 1,
        stock: 100,
        precio: 200.00,
        imagenes: [],
        color: ["Rojo"],
        especificaciones: [],
        product_cloud_Id: "pin-corazon-rojo-101"
      },
      
      {
        id: 50,
        titulo: "Pin Corazón Humano 🫀",
        descripcion: "¿Conoces a alguien que es un cardiólogo, tiene un alto coeficiente intelectual? o está estudiando cardiología o es cardiólogo? Este pin es el regalo perfecto para llevar con orgullo en su scrub, cordón o carnet de identificación. Nuestro pin de corazón humano está hecho de proceso cloisonné de calidad de joyería, relleno de esmalte duro, niquelado y pulido a una presentación suave al tacto. Es la pieza perfecta para un regalo en una conferencia, evento médico o reunión grupal o para crear conciencia sobre cuidar nuestro corazón.",
        rating: 1,
        talla: [],
        material: "Esmalte duro, Niquelado",
        categoria: "Accesorios",
        isFeatured: false,
        cantidad: 1,
        stock: 100,
        precio: 350.00,
        imagenes: [],
        descuento:50,
        color: ["No especificado"],
        especificaciones: [],
        product_cloud_Id: "pin-corazon-humano-101"
      },
      
      {
        id: 51,
        titulo: "Pin Logo UASD",
        descripcion: "El diseño de cierre de mariposa en la parte posterior de cada pin esmaltado hace que sea fácil de fijar a tu ropa, puedes usarlo y quitarlo sin complicaciones, fácil de operar y almacenar. Adecuado para la decoración de vestidos, suéteres, bufandas, bolsos, chaquetas, mochilas, etc demuestra el orgullo UASDiano con estilo, el precio más abajo es por cada uno.",
        rating: 0,
        talla: [],
        material: "Esmalte",
        categoria: "Accesorios",
        isFeatured: false,
        cantidad: 1,
        stock: 100,
        precio: 350.00,
        imagenes: [],
        descuento:50,
        color: ["No especificado"],
        especificaciones: [],
        product_cloud_Id: "pin-logo-uasd-101"
      }
,      
{
  id: 52,
  titulo: "Pin Pulmon",
  descripcion: "Nuestro Pin de solapa de pulmones puede ser dirigido a médicos, enfermeras, especialistas pulmonares o alguien que está luchando contra enfermedades pulmonares o cáncer de pulmón. Este pin está hecho del proceso de calidad de joyería cloisonné. Está relleno de esmalte duro, está niquelado y pulido para un acabado fino y liso.",
  rating: 0,
  talla: [],
  material: "Esmalte duro, Niquelado",
  categoria: "Accesorios",
  isFeatured: false,
  cantidad: 1,
  stock: 100,
  precio: 350.00,
  descuento:50,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "pin-pulmon-101"
},

{
  id: 53,
  titulo: "Pin de Ojo",
  descripcion: "Este es un pin ideal para colocar en tu scrub y bata al momento de ir a tus servicios al hospital.",
  rating: 0,
  talla: [],
  material: "No especificado",
  categoria: "Accesorios",
  isFeatured: false,
  cantidad: 1,
  stock: 100,
  precio: 200.00,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  descuento:50,
  product_cloud_Id: "pin-ojo-101"
},
{
  id: 54,
  titulo: "Pin de estetoscopio",
  descripcion: "Pin de estetoscopio en 8 estilos, suficientes para su uso diario, reemplazar y compartir con amigos. Cada pin de alfiler mide aproximadamente 1.18 x 0.63 pulgadas, pesa aproximadamente 0.07 onzas, que es ligero y fácil de transportar sin que te sientas demasiado pesado. Aspecto novedoso: estos broches están diseñados con forma de estetoscopio, realista, exquisita en mano de obra y colores brillantes, puedes utilizarlos para decorar tu suéter, bufanda, vestido, bolsos, bolso, ropa, sombreros, bolsas u otros artículos, lo que mostrará tu buen gusto y te dará una impresión totalmente fresca.",
  rating: 0,
  talla: [],
  material: "No especificado",
  categoria: "Accesorios",
  isFeatured: false,
  descuento:50,
  cantidad: 1,
  stock: 100,
  precio: 150.00,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "pin-estetoscopio-101"
},
{
  id: 55,
  titulo: "Pines Organos Humano",
  descripcion: "Estos pines son el regalo perfecto para llevar con orgullo en tu bata o scrub, cordón o junto a tu carnet. Nuestros pines de solapas están hechos de proceso cloisonné de calidad de joyería, relleno de esmalte duro, niquelado y pulido a una presentación suave al tacto. Es la pieza perfecta para adornar tu scrub mientras vas a tu guardia hospitalaria.",
  rating: 0,
  talla: [],
  material: "Esmalte duro, Niquelado",
  categoria: "Accesorios",
  isFeatured: false,
  cantidad: 1,
  stock: 100,
  precio: 350.00,
  descuento:50,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "pines-organos-humano-101"
},
{
  id: 56,
  titulo: "Pines esmaltados de órganos",
  descripcion: "Alta calidad: los exquisitos pines están pintados a mano y cada pin es único, con aleación y esmalte como proceso principal. Están hechos de aleación de alta calidad para mayor durabilidad, y no hay necesidad de preocuparse de que se le desvanezca el color. Estos broches son seguros de llevar.",
  rating: 1,
  talla: [],
  material: "Aleación, Esmalte",
  categoria: "Accesorios",
  isFeatured: false,
  cantidad: 1,
  stock: 100,
  precio: 350.00,
  imagenes: [],
  descuento:50,
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "pines-esmaltados-organos-101"
},
{
  id: 57,
  titulo: "Termómetro de Mercurio",
  descripcion: "Perfecto para personal del sector salud, para uso en casa es fácil de usar y proporciona una representación más granular de los cambios de temperatura.",
  rating: 0,
  talla: [],
  material: "Vidrio, Mercurio",
  categoria: "Equipos médicos",
  isFeatured: false,
  cantidad: 1,
  stock: 100,
  precio: 200.00,
  imagenes: [],
  descuento:50,
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "termometro-mercurio-101"
},
{
  id: 58,
  titulo: "Termómetro digital de oído para adultos y niños",
  descripcion: "Fácil de usar: control con un botón: obtén resultados en segundos con el termómetro digital. Una vez completada la medición, se calibra automáticamente y la siguiente medición se puede tomar rápidamente, lo que es adecuado para múltiples personas o múltiples mediciones.",
  rating: 0,
  talla: [],
  material: "Plástico, Componentes electrónicos",
  categoria: "Equipos médicos",
  isFeatured: false,
  cantidad: 1,
  stock: 100,
  precio: 950.00,
  descuento:50,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "termometro-digital-oido-101"
},

{
  id: 59,
  titulo: "Termómetro digital para adultos y niños",
  descripcion: "Termómetro oral seguro para adultos: la punta de silicona suave con sonda de acero inoxidable es confiable. Un termómetro médico que se puede usar por vía oral, rectal o axila. Conveniente y seguro para ti y tu familia.\n\nLectura precisa y rápida: aproximadamente 10 segundos de tiempo de lectura. Este termómetro basal digital utiliza la última sonda sensorial avanzada y la lectura de temperatura está clínicamente probada y detecta con precisión la fiebre, ayudándote a determinar si necesitas un descanso o atención médica.",
  rating: 0,
  talla: [],
  material: "Silicona, Acero inoxidable",
  categoria: "Equipos médicos",
  isFeatured: false,
  cantidad: 1,
  stock: 100,
  descuento:50,
  precio: 450.00,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "termometro-digital-101"
},
{
  id: 60,
  titulo: "Termómetro sin contacto para adultos y niños",
  descripcion: "Lecturas rápidas y fáciles de temperaturas: tomar la temperatura de tu familia con el termómetro de frente GoodBaby es tan simple como apuntar y presionar un botón. Utiliza tecnología infrarroja y puede mostrar lecturas en grados Celsius o Fahrenheit.\n\nTecnología avanzada para un excelente rendimiento: utiliza materiales confiables de la carcasa del ABS. Diseño ergonómico, el agarre firme hace que sea fácil incluso para niños traviesos.",
  rating: 0,
  talla: [],
  material: "ABS, Tecnología infrarroja",
  categoria: "Equipos médicos",
  isFeatured: false,
  cantidad: 1,
  stock: 100,
  precio: 1350.00,
  descuento:50,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "termometro-sin-contacto-101"
},

{
  id: 61,
  titulo: "Tirillas EasyTouch paquete de 50 unidades",
  descripcion: "Tiras reactivas de glucosa: ideales para autoanálisis en casa o en movimiento, nuestras tiras reactivas para la diabetes requieren solo una pequeña muestra de sangre.\n\nResultados rápidos: estas tiras de prueba de glucosa en sangre ofrecen resultados en solo 5 segundos; para mayor comodidad, alterna entre probar las palmas, antebrazos y yemas de los dedos.\n\nCompatible con: Sistema de monitoreo de glucosa EasyTouch solamente.\n\nIncluye: 50 tiras reactivas.\n\nNuestra promesa: MHC Medical Products respalda su promesa de ofrecer productos de calidad en los que pueda confiar y la comodidad que pueda sentir; si no está satisfecho, háganoslo saber, y lo haremos bien.",
  rating: 0,
  talla: [],
  descuento:50,
  material: "Reactivos de glucosa",
  categoria: "Equipos médicos",
  isFeatured: false,
  cantidad: 1,
  stock: 100,
  precio: 950.00,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "tirillas-easytouch-50-101"
},
{
  id: 62,
  titulo: "Tirillas Prodigy Paquete de 50 unidades",
  descripcion: "Las tiras reactivas Prodigy no requieren codificación.\n\nEl paquete incluye 50 tirillas reactivas, las cuales son desechables luego de utilizarlas. No requieren ningún tipo de codificación, simplemente introdúzcalas en el glucómetro y estarán listas para usarse.",
  rating: 0,
  talla: [],
  material: "Reactivos de glucosa",
  categoria: "Equipos médicos",
  isFeatured: false,
  cantidad: 1,
  descuento:50,
  stock: 100,
  precio: 1200.00,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "tirillas-prodigy-50-101"
}
,
{
  id: 63,
  titulo: "Tirillas True Metrix Paquete de 50 Unidades",
  descripcion: "Las tiras reactivas True Metrix requieren solo una pequeña muestra de sangre de 0.5 microlitros.\n\nCaracterísticas:\n- Tecnología Triple Sense para mayor precisión.\n- Fabricadas en Estados Unidos.\n- Compatibles únicamente con medidores de glucosa TRUE METRIX, TRUE METRIX AIR y TRUE METRIX GO.\n- Diseñadas para uso individual y no deben ser compartidas.",
  rating: 0,
  talla: [],
  material: "Reactivos de glucosa",
  categoria: "Equipos médicos",
  isFeatured: false,
  descuento:50,
  cantidad: 1,
  stock: 100,
  precio: 1150.00,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "tirillas-true-metrix-50-101"
},
{
  id: 64,
  titulo: "Glucometro Easy • Touch",
  descripcion: "Kit de monitor de glucosa: utiliza este kit de prueba de azúcar en sangre para obtener una muestra de sangre de tu antebrazo, palma o yemas de los dedos; cuenta con función de encendido/apagado automático y suficiente memoria para 300 resultados de pruebas de historia recientes.\n\nMedidor de glucosa: ideal para uso en movimiento o como prueba casera de diabetes, este monitor de azúcar en sangre ofrece resultados en solo 5 segundos y requiere solo una pequeña muestra de sangre.\n\nLancetas giratorias: nuestra lanceta de corte de triple bisel está diseñada para adaptarse a los dispositivos de punción más utilizados y cuenta con una variedad de medidores, todos codificados por colores, diseñados para adaptarse a su nivel de comodidad.\n\nDispositivo de punción: Diseñado para su uso con dispositivos más comunes, este dispositivo de punción tiene una función de reducción de vibración incorporada que permite un pinchazo más cómodo al probar.",
  rating: 0,
  talla: [],
  material: "Reactivos de glucosa",
  categoria: "Equipos médicos",
  isFeatured: false,
  descuento: 50,
  cantidad: 1,
  stock: 100,
  precio: 900.00,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "glucometro-easy-touch-101"
},
{
  id: 65,
  titulo: "Pin Caduceo Vara Esculapio",
  descripcion: "Este pin Caduceo muy clásico es ampliamente utilizado por profesionales médicos, incluyendo médicos, profesionales de enfermería y médicos militares. El Caduceo se ha convertido en el símbolo no oficial de médicos y asociaciones médicas. Este pin de solapa está troquelado de metal de joyería premium.",
  rating: 0,
  talla: [],
  material: "Metal de joyería premium",
  categoria: "Accesorios médicos",
  isFeatured: false,
  descuento: 0,
  cantidad: 1,
  stock: 100,
  precio: 200.00,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "pin-caduceo-vara-esculapio-101"
},

{
  id: 66,
  titulo: "Dixie EMS Juego de esfigmomanómetro",
  descripcion: "Fácil de leer: el dial de alto contraste en el manómetro de aleación de aluminio permite al usuario leer las medidas de presión arterial de forma fácil y precisa. La esfera cuenta con un clip resistente que se fija a la ropa o cinturones cuando no está en uso.\n\nPuño de tamaño adulto: el puño de nailon cuenta con un rango de tamaño de 10.0 in a 16.0 in. Tamaño ideal para uso en adultos.\n\nSin látex: fabricado pensando en personas alérgicas para evitar cualquier irritación no deseada o reacción alérgica para que puedas mantenerte tranquilo.",
  rating: 0,
  talla: [],
  material: "Aleación de aluminio y nailon",
  categoria: "Equipos médicos",
  isFeatured: false,
  descuento: 50,
  cantidad: 1,
  stock: 100,
  precio: 1950.00,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "dixie-ems-esfigmomanometro-101"
},
{
  id: 67,
  titulo: "Esfigmomanómetro Digital",
  descripcion: "Máquina de presión arterial precisa y rápida: cada máquina de presión arterial AILE está calibrada individualmente, utilizando chips holandeses de alta precisión y algoritmos de última generación para garantizar una precisión sin igual para cada dispositivo. Los monitores de presión arterial AILE proporcionan presiones diastólicas y sistólicas confiables, así como frecuencia cardíaca en solo 30 segundos. Error de medición: Presión arterial dentro de 3 mmHg, pulso dentro del 5%. Preciso y rápido, te mereces tenerlo!",
  rating: 0,
  talla: [],
  material: "Componentes electrónicos y nailon",
  categoria: "Equipos médicos",
  isFeatured: false,
  descuento: 50,
  cantidad: 1,
  stock: 100,
  precio: 1950.00,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "esfigmomanometro-digital-101"
},
{
  id: 68,
  titulo: "Estetoscopio de doble tubo para adultos y pediátricos + tijera de trauma",
  descripcion: "Claridad acústica mejorada: experimenta un sonido superior con el estetoscopio ASA TECHMED Sprague Rappaport, diseñado para evaluaciones de sonido Korotkoff precisas y exámenes físicos completos.\n\nDiseño versátil de doble cabezal: cuenta con una válvula acústica giratoria y una pieza torácica de doble cabeza para diagnosticar afecciones cardíacas y respiratorias, esencial para los profesionales de la salud.\n\nConstrucción ligera y duradera: hecha de aluminio ligero y pulido a mano para mayor durabilidad. Incluye tubo de PVC sin látex y puntas de silicona suave para mayor comodidad.",
  rating: 0,
  talla: [],
  material: "Aluminio y PVC",
  categoria: "Equipos médicos",
  isFeatured: false,
  descuento: 50,
  cantidad: 1,
  stock: 100,
  precio: 1050.00,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "estetoscopio-doble-tubo-101"
},
{
  id: 69,
  titulo: "Estetoscopio 3M Littmann Lightweight II S.E.",
  descripcion: "Proporciona un rendimiento acústico fiable para tomar lecturas de presión arterial y hacer evaluaciones físicas limitadas de pacientes adultos.\n\nEl diafragma ajustable responde con un simple cambio de presión para capturar sonidos de baja y alta frecuencia.\n\nForma de lágrima para un fácil ajuste bajo el puño de presión arterial.\n\nLos auriculares de diseño anatómico están en ángulo para cumplir con el camino del canal auditivo; el borde y el diafragma Nonchill proporcionan una comodidad bienvenida al paciente.",
  rating: 0,
  talla: [],
  material: "Aluminio y PVC",
  categoria: "Equipos médicos",
  isFeatured: false,
  descuento: 50,
  cantidad: 1,
  stock: 100,
  precio: 4950.00,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "estetoscopio-littmann-lightweight-ii-se-101"
},
{
  id: 70,
  titulo: "Estetoscopio MDF ProCardial - de Cardiología",
  descripcion: "Hechos a mano desde 1971, sin látex.\n\nEstetoscopio de grado cardiológico: diseño tradicional de cardiología, con dos canales de sonido, uno para cada oreja, y tubo de doble lumen.\n\nSeguro: resorte con estructura de doble hoja que ofrece el doble de durabilidad.\n\nEn ángulo: los auriculares Ergonomax están hechos en un ángulo de 15 grados para un ajuste preciso.",
  rating: 0,
  talla: [],
  material: "Aluminio y PVC",
  categoria: "Equipos médicos",
  isFeatured: false,
  descuento: 50,
  cantidad: 1,
  stock: 100,
  precio: 5800.00,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "estetoscopio-mdf-procardial-101"
},
{
  id: 71,
  titulo: "Estetoscopio MDF Acoustica Deluxe",
  descripcion: "Hecho a mano desde 1971. Sin látex.\n\nEstetoscopio ligero multiusos: duradero, cómodo y de alto rendimiento sonoro.\n\nDoblemente seguro: resorte con estructura de doble hoja que ofrece el doble de durabilidad.\n\nPreviene la perforación de tímpanos: las ojivas patentadas SafetyLock no son invasivas y se enfocan en la seguridad del usuario.",
  rating: 0,
  talla: [],
  material: "Aluminio y PVC",
  categoria: "Equipos médicos",
  isFeatured: false,
  descuento: 50,
  cantidad: 1,
  stock: 100,
  precio: 2350.00,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "estetoscopio-mdf-acoustica-deluxe-101"
},
{
  id: 72,
  titulo: "Glucometro True Metrix",
  descripcion: "Medidor de glucosa: ideal para uso en movimiento o como prueba casera de diabetes, este monitor de azúcar en sangre ofrece resultados en solo 5 segundos y requiere solo una pequeña muestra de sangre.\n\nDiseñado para su uso con dispositivos más comunes, este dispositivo de punción tiene una función de reducción de vibración incorporada que permite un pinchazo más cómodo al probar.",
  rating: 0,
  talla: [],
  material: "Reactivos de glucosa",
  categoria: "Equipos médicos",
  isFeatured: false,
  descuento: 50,
  cantidad: 1,
  stock: 100,
  precio: 1150.00,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "glucometro-true-metrix-101"
},
{
  id: 73,
  titulo: "Esfigmomanómetro Welch Allyn",
  descripcion: "Este esfigmomanómetro Allyn DuraShock DS44-11 compacto y ligero es duradero y fácil de usar. Está libre de látex y cuenta con tecnología DuraShock que le da a este dispositivo una vida útil más larga que los esfigmomanómetros aneroides tradicionales.",
  rating: 0,
  talla: [],
  material: "Aleación de aluminio",
  categoria: "Equipos médicos",
  isFeatured: false,
  descuento: 50,
  cantidad: 1,
  stock: 100,
  precio: 2600.00,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "esfigmomanometro-welch-allyn-101"
},
{
  id: 74,
  titulo: "Esfigmomanómetro",
  descripcion: "Las campanas y silbatos Al integrar la bombilla la válvula de aire y el dial sin látex en una sola unidad el esfigmomanómetro es fácil de usar con una sola mano lo que lo convierte en la opción óptima para una máquina manual de presión arterial Además las características de diseño intencionales como una pieza de metal en la bombilla de aire ayudan a una compresión más fácil\n\nSimple e intuitivo este monitor de presión arterial fácil de leer y fácil de usar cuenta con un dial estéticamente agradable con grandes números y está codificado por colores para resaltar el rango saludable promedio",
  rating: 1,
  talla: [],
  material: "Aleación de aluminio",
  categoria: "Equipos médicos",
  isFeatured: false,
  descuento: 50,
  cantidad: 1,
  stock: 100,
  precio: 2350.00,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "esfigmomanometro-101"
},
{
  id: 75,
  titulo: "Esfigmomanometro Paramed",
  descripcion: "No estetoscopio en el juego el estetoscopio no está incluido Mantén un registro de tu presión arterial brazalete universal tamaño 8.7-16.5 in que está hecho de nailon extra duradero cómoda tira de velcro que permite medir fácilmente con una mano en casa para equilibrar tu presión arterial\n\nObtenga resultados fiables equipado con una válvula de aguja de aire de metal de prestigio con una regulación de alivio de presión suave y un dial numérico grande y fácilmente legible Clínicamente probado y aprobado",
  rating: 1,
  talla: [],
  material: "Nailon y metal",
  categoria: "Equipos médicos",
  isFeatured: false,
  descuento: 50,
  cantidad: 1,
  stock: 100,
  precio: 1800.00,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "esfigmomanometro-paramed-101"
},
{
  id: 76,
  titulo: "Estetoscopio 3M Littmann Classic III",
  descripcion: "Controla y evalúa una amplia gama de pacientes detecta sonidos y ritmos normales y anormales diseñado para usar con pacientes adultos y pediátricos ivertido y sonoro; combina el color y el acabado con tu personalidad fabricado en EE. UU. Sin látex de caucho natural Las piezas auriculares de sellado suave proporcionan una comodidad óptima y una excelente oclusión sonora Manga acampanada aislante de frío para una mayor comodidad del paciente.",
  rating: 2,
  talla: [],
  material: "Caucho natural sin látex",
  categoria: "Equipos médicos",
  isFeatured: false,
  descuento: 50,
  cantidad: 1,
  stock: 100,
  precio: 7800.00,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "estetoscopio-3m-littmann-classic-iii-101"
},
{
  id: 78,
  titulo: "Glucometro Prodigy",
  descripcion: "No requiere codificación Medidor parlante (resultados audibles ideales para baja visión) Resultados rápidos de las pruebas en solo 6 segundos Para menos dolor - Muestra de sangre pequeña más pruebas de sitio alternativas: - Prueba en el antebrazo, la parte superior del brazo, el muslo, la pantorrilla, la mano y el dedo.",
  rating: 0,
  talla: [],
  material: "Reactivos de glucosa",
  categoria: "Equipos médicos",
  isFeatured: false,
  descuento: 50,
  cantidad: 1,
  stock: 100,
  precio: 1050.00,
  imagenes: [],
  color: ["No especificado"],
  especificaciones: [],
  product_cloud_Id: "glucometro-prodigy-101"
},
{
  id: 79,
  titulo: "Kit de diagnóstico de 7 piezas",
  descripcion: "Martillo Taylor, cinta métrica, diapasones, tijeras de vendaje, lápiz de calibre de pupila, tabla de ojos Snellen (plateado)Precisión y durabilidad: cuenta con diapasones y un martillo Taylor para evaluaciones físicas precisas, todo hecho de acero inoxidable duradero. Ideal para uso diario profesional. Fácil de usar y evaluación de la visión: diseñado para facilitar la operación con una práctica funda con cremallera. También incluye un gráfico Snellen Eye Chart y Pupil Gauge Penlight para exámen",
  rating: 1,
  talla: [],
  material: "Acero inoxidable",
  categoria: "Equipos médicos",
  isFeatured: false,
  descuento: 50,
  cantidad: 1,
  stock: 100,
  precio: 1950.00,
  imagenes: [],
  color: ["Plateado"],
  especificaciones: [],
  product_cloud_Id: "kit-de-diagnostico-de-7-piezas-101"
},
{
  id: 80,
  titulo: "Kit de diagnóstico otoscopio 3 en 1 de alta calidad",
  descripcion: "Juego de diagnóstico oph de otoscopio 3 en 1 de alta calidad - Otoscopio multifunción - Kit para estudiantes de hogar y enfermería - Tabla de vista, consejos de repuesto, práctica de caso fácil de llevar, perfecto y prueba tus habilidades de diagnóstico con un kit de alcance completo para ojos, oídos, nariz y garganta. Los otoscopios son una herramienta de diagnóstico utilizada para mirar dentro del oído durante los chequeos físicos. Equipado con una luz LED y una lente de aumento, los otoscopios son comunes en casi cualquier centro de atención. Los otoscopios también vienen con espéculos de diferentes tamaños para ayudar a ajustar la lente del otoscopio en el canal auditivo externo.",
  rating: 0,
  talla: [],
  material: "Metal y plástico",
  categoria: "Equipos médicos",
  isFeatured: false,
  descuento: 0,
  cantidad: 1,
  stock: 50,
  precio: 4800.00,
  imagenes: [],
  color: ["Negro"],
  especificaciones: [],
  product_cloud_Id: "kit-de-diagnostico-otoscopio-3-en-1-de-alta-calidad-101"
},
{
  id: 81,
  titulo: "Kit De Sutura Completo",
  descripcion: "El kit de práctica de sutura le ayudará a perfeccionar sus técnicas de sutura en el emulador de piel de alta calidad. Esta almohadilla de sutura replica una amplia gama de cortes comunes, que le ayudarán a practicar diferentes técnicas de sutura. Instrumentos de acero de alta calidad: nuestros instrumentos de acero están hechos de acero inoxidable de grado quirúrgico. Se puede esterilizar de varias maneras sin daños. Antioxidante y duradero, ideal para estudiantes de medicina.",
  rating: 0,
  talla: [],
  material: "Acero inoxidable y silicona",
  categoria: "Equipos médicos",
  isFeatured: false,
  descuento: 0,
  cantidad: 1,
  stock: 100,
  precio: 1350.00,
  imagenes: [],
  color: ["Plateado"],
  especificaciones: [],
  product_cloud_Id: "kit-de-sutura-completo-101"
},
{
  id: 82,
  titulo: "Kit de diagnóstico Otoscopio 2 en 1",
  descripcion: "Con este juego de otoscopio/oftalmoscopio ZYREV ZetaLife, ahora puedes hacer exámenes completos de oídos y ojos con una herramienta increíble. Proporciona la cantidad perfecta de iluminación y aumento para examinar a fondo tanto los oídos como los ojos, todo mientras es extremadamente portátil.",
  rating: 0,
  talla: [],
  material: "Plástico y acero inoxidable",
  categoria: "Equipos médicos",
  isFeatured: false,
  descuento: 0,
  cantidad: 1,
  stock: 100,
  precio: 4900.00,
  imagenes: [],
  color: ["Negro", "Plateado"],
  especificaciones: [],
  product_cloud_Id: "kit-de-diagnostico-otoscopio-2-en-1-101"
},
{
  id: 83,
  titulo: "Mini Doppler",
  descripcion: "Este producto es de mano, alimentado por batería de audio Doppler diseñado para uso doméstico. Está destinado a detectar y mostrar la frecuencia cardíaca fetal. El dispositivo está diseñado para su uso en o después de 12 semanas de gestación. Tiene dos componentes de mano, una unidad principal y una sonda. La señal ultrasónica se transmite continuamente a una frecuencia de 3,0 MHz.",
  rating: 0,
  talla: [],
  material: "Plástico y componentes electrónicos",
  categoria: "Equipos médicos",
  isFeatured: false,
  descuento: 0,
  cantidad: 1,
  stock: 100,
  precio: 5900.00,
  imagenes: [],
  color: ["Blanco"],
  especificaciones: [],
  product_cloud_Id: "mini-doppler-101"
},
{
  id: 84,
  titulo: "Parches para aliviar el dolor",
  descripcion: "Incluye un (1) paquete de cinco unidades de parches Icy Hot Pro para aliviar el dolor sin ensuciar con mentol y alcanfor. Alivio potente y de acción rápida para dolores musculares y articulaciones. Esta fórmula extra fuerte contiene mentol y alcanfor, dos potentes analgésicos. Los parches para aliviar el dolor con tecnología avanzada de hidrogel ofrecen una sensación de enfriamiento inmediata. El parche para aliviar el dolor se puede usar hasta ocho horas. El forro de embalaje contiene citas motivacionales para inspirar.",
  rating: 0,
  talla: [],
  material: "Hidrogel con mentol y alcanfor",
  categoria: "Cuidado y alivio del dolor",
  isFeatured: false,
  descuento: 0,
  cantidad: 1,
  stock: 100,
  precio: 900.00,
  imagenes: [],
  color: ["Blanco"],
  especificaciones: [],
  product_cloud_Id: "parches-alivio-dolor-101"
}


  
  ];
  

// Usar un mapa para asociar imágenes de forma eficiente
const imagenesMap: { [key: string]: string[] } = imagenes; // Deberías tener un objeto donde las claves sean los IDs de productos

productos.forEach(producto => {
  // Accedemos a las imágenes de manera eficiente usando un Map
  producto.imagenes = imagenesMap[producto.product_cloud_Id] || [];
});

console.log(productos);
document.body.setAttribute('data-productos', JSON.stringify(productos));

  